import api, { getAllPages } from './api-service';

/**
 * Group-owned machine identities and their tokens.
 *
 * Distinct from PersonalAccessTokenService: those credentials act as the signed-in person, these act
 * as the service account and are shared by whoever is named a manager on the owning group.
 */
const ServiceAccountService = {
	list(group) {
		const params = group ? { group } : {};
		// Admins can span many groups and the preferences table renders the whole list
		// without pagination, so fetch every page.
		return getAllPages('/service-accounts', { params });
	},

	create({ name, group, description }) {
		return api.client
			.post('/service-accounts', { name, group, description })
			.then((res) => res.data);
	},

	update(id, data) {
		return api.client.patch(`/service-accounts/${id}`, data).then((res) => res.data);
	},

	disable(id) {
		return api.client.delete(`/service-accounts/${id}`);
	},

	listTokens(id) {
		return api.client.get(`/service-accounts/${id}/tokens`).then((res) => res.data);
	},

	/**
	 * Returns the token including its plaintext `token` value. That value is only ever present in
	 * this response — it is not stored and cannot be retrieved again.
	 */
	issueToken(id, { name, expiresAt }) {
		return api.client
			.post(`/service-accounts/${id}/tokens`, { name, expiresAt })
			.then((res) => res.data);
	},

	revokeToken(id, tokenId) {
		return api.client.delete(`/service-accounts/${id}/tokens/${tokenId}`);
	}
};

export default ServiceAccountService;
